<!-- SPDX-License-Identifier: AGPL-3.0-or-later -->

<mat-card class="party-picture-card">
  <div class="image-container" [style.background-color]="getBackgroundColor()">
    <img class="images" src="{{ imageUrl }}" alt="party pic" />
  </div>
  <div class="middle-bar">
    <p>Author: {{ picture?.author }}</p>
    <p>{{ picture?.title }}</p>
  </div>
  <div class="bottom-bar">
    <div>
      @if (picture?.state === 'PENDING' || picture?.state === 'REJECTED') {
        <button
          mat-icon-button
          aria-label="Approve picture"
          matTooltip="Approve picture"
          (click)="openConfirmDialog('approve')"
        >
          <mat-icon>check</mat-icon>
        </button>
      }
      @if (picture?.state === 'PENDING' || picture?.state === 'APPROVED') {
        <button
          mat-icon-button
          aria-label="Reject picture"
          matTooltip="Reject picture"
          (click)="openConfirmDialog('reject')"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
      <button
        mat-icon-button
        aria-label="Delete picture"
        matTooltip="Delete picture"
        (click)="openConfirmDialog('delete')"
      >
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>
</mat-card>
